<div class="cookie-consent-container">
  <p class="mt-0">{{ title() }}</p>
  <div class="mb-4">
    <app-cookie-table [cookies]="cookies()" />
  </div>
</div>
